import React from "react";

export const ProfessionalSummarySection = ({ formData }) => (
  <div className="summary-section">
    <h4>Professional Information</h4>
    {formData.affiliation && (
      <div className="summary-row">
        <span className="summary-label">Affiliation:</span>
        <span className="summary-value">{formData.affiliation}</span>
      </div>
    )}
    {formData.institution && (
      <div className="summary-row">
        <span className="summary-label">Institution:</span>
        <span className="summary-value">{formData.institution}</span>
      </div>
    )}
    <div className="summary-row">
      <span className="summary-label">MCI Registered:</span>
      <span className="summary-value">{formData.mciRegistered}</span>
    </div>
    {formData.mciRegistered === "Yes" && formData.mciNumber && (
      <div className="summary-row">
        <span className="summary-label">MCI Number:</span>
        <span className="summary-value">{formData.mciNumber}</span>
      </div>
    )}
  </div>
);
